import { LOYALTY_STATUS, LoyaltyStatus, STATUS_CODE } from "../constants/loyalty-scan";

export const checkIsEligible = (statusCode: number): LoyaltyStatus => {
    switch (statusCode) {
        case STATUS_CODE.ELIGIBLE:
            return LOYALTY_STATUS.ELIGIBLE;
        default:
            return LOYALTY_STATUS.INELIGIBLE;
    }
};

export const DINEOUT_HOME_DEEPLINK = "swiggydiners://home?reloadHome=true";

export const TRY_AGAIN = "Try Again";
